export default [
  {
    path: '/contabilita/importa-tracciati',
    name: 'importa-tracciati-contabilita',
    component: () => import('@/views/contabilita/PaginaImportaTracciatiContabilita.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Importazione',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/importa-zip',
    name: 'importa-zip-contabilita',
    component: () => import('@/views/contabilita/PaginaImportaTracciatoZip.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Importazione',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/registrazioni',
    name: 'registrazioni-contabili',
    component: () => import('@/views/contabilita/PaginaRegistrazioniContabili.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Registrazioni Contabili',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/registrazioni-ministero',
    name: 'registrazioni-contabili-ministero',
    component: () => import('@/views/contabilita/PaginaRegistrazioniContabiliMinistero.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Registrazioni Contabili Ministero',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/gestione-destinatari',
    name: 'gestione-destinatari-contabilita',
    component: () => import('@/views/contabilita/PaginaDestinatari.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Gestione Destinatari Contabilità',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/tabella-raccordo-destinatari',
    name: 'tabella-raccordo-destinatari',
    component: () => import('@/views/contabilita/PaginaTabellaRaccordoDestinatari.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Tabella Raccordo Contabilità',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/cashflow',
    name: 'cashflow',
    component: () => import('@/views/contabilita/PaginaCashFlow.vue'),
    meta: {
      resource: 'cashflow',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Cash Flow',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/distinte',
    name: 'distinte',
    component: () => import('@/views/contabilita/PaginaDistintePagamenti.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Distinte Pagamenti',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/ordini',
    name: 'ordini',
    component: () => import('@/views/contabilita/PaginaOrdini.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Ordini',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/bolle',
    name: 'bolle',
    component: () => import('@/views/contabilita/PaginaBolle.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Bolle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/verifica-bilancio',
    name: 'verifica-bilancio',
    component: () => import('@/views/contabilita/PaginaVerificaBilancio.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Verifica Bilancio',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/importa-prev-spettacoli',
    name: 'importa-prev-spettacoli',
    component: () => import('@/views/contabilita/PaginaImportaPreventivo.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Importa preventivi spettacoli',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/allegato-c',
    name: 'allegato-c',
    component: () => import('@/views/contabilita/PaginaAllegatoC.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Allegato C',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/bilancio-progetti',
    name: 'bilancio-progetti',
    component: () => import('@/views/contabilita/PaginaBilancioProgetti.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Bilancio Progetti',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/contributiSponsorship',
    name: 'contributi-sponsorship',
    component: () => import('@/views/contabilita/PaginaContributiSponsorship.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Contributi & Sponsorship',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/speseComunicazione',
    name: 'spese-comunicazione',
    component: () => import('@/views/contabilita/PaginaSpeseComunicazione.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Spese Comunicazione',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/verifica-pagamenti',
    name: 'verifica-pagamenti',
    component: () => import('@/views/contabilita/PaginaVerificaPagamenti.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Verifica Pagamenti',
          active: true,
        },
      ],
    },
  },
  {
    path: '/contabilita/scadenziario',
    name: 'scadenziario',
    component: () => import('@/views/contabilita/PaginaScadenziario.vue'),
    meta: {
      resource: 'contabilita',
      action: 'read',
      breadcrumb: [
        {
          text: 'Contabilità',
        },
        {
          text: 'Scadenziario',
          active: true,
        },
      ],
    },
  },

]
